// ---------------------------------------------------------------------------
// BrandName — renders "YouAreYou" with the verified badge, matching the
// YouAreYou brand logo:
//   • "You"      bold, dark charcoal
//   • "Are"      bold, dark charcoal
//   • "You"      bold, #0052FF blue
//   • green verified badge (circle + checkmark) inline
// ---------------------------------------------------------------------------

interface BrandNameProps {
  /** Show the green "Verified" badge inline. Default: true */
  showBadge?: boolean;
}

export default function BrandName({ showBadge = true }: BrandNameProps) {
  return (
    <span className="inline-flex items-center gap-0.5 font-bold leading-none">
      <span className="text-[#161b27]">You</span>
      <span className="text-[#f08b8b]">Are</span>
      <span className="text-[#161b27]">You</span>
      {showBadge && (
        <span className="ml-0.5 inline-flex h-[1.1em] w-[1.1em] items-center justify-center rounded-full bg-[#3CB043] flex-shrink-0" aria-label="Verified">
          <svg viewBox="0 0 12 12" fill="none" className="h-[0.65em] w-[0.65em]" aria-hidden="true">
            <path
              d="M2 6.5L4.8 9.2L10 3"
              stroke="white"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </span>
  );
}
